export const KEY_DEALER_DATA = 'fa-header-dealer-data'; // Dealer data in session storage for Header
export const DEALER_CONTEXT_UNSUBSCRIBE = 'unsubscribe'; // session storage variable to prevent re-connecting if user voluntarily unsubscribes
export const DEALER_CONTEXT_AUTOCONNECT_UNSUBSCRIBE = 'auto-connected-unsubscribe'; // session storage variable to prevent re-connecting if user voluntarily unsubscribes with auto-connect to dealer enabled
export const DEALER_CONNECTED_NOTIFICATION = 'fa-header-dealer-connected'; // session storage variable to prevent re-creating notifications about dealer connection
export const customEaseOut = 'cubic-bezier(0.21, 0.55, 0.43, 1)';
export const MAX_LENGTH_DEALER_NAME = 30;
export const LAMBDA_CUSTOMER_PROFILE_URL_TEST =
  'https://fa-nemo-header.api.dev.arcade.apps.one.audi/api';
export const LAMBDA_CUSTOMER_PROFILE_URL_LIVE =
  'https://fa-nemo-header.api.prod.arcade.apps.one.audi/api';
export const MY_AUDI_ID = 'a2c-session-token';
export const AUDI_AUTH_STORE = 'audi:authStore';
export const NAVIGATION_CLASSNAME = 'navigation';
export const NAVIGATION_MOBILE_CLASSNAME = 'mobile-navigation';
export const SUB_NAVIGATION_CLASSNAME = 'sub-navigation';
export const AUTH_OIDC_USER_INFO = {
  url: '/oidc/userinfo',
  resourceHostId: 'idk-userinfo',
  sessionKey: 'oidcUser', // Auth oidc user info
};
export const AUTH_PROFILE_PICTURE = {
  url: `boac/v1/${__FEATURE_APP_VERSION__}/profile-picture`, // alternative url to use: `${oidcUser.sub}/profile-picture`
  resourceHostId: 'retailservices', // Alternative resourceHostId to use with url `${oidcUser.sub}/profile-picture`: 'fa-nemo-header-prod'
  sessionKey: 'profilePicture',
};
